import {
  ProjectPageContext,
  type ProjectPageContextValue,
} from "./project-page-context-hooks";

export function ProjectPageProvider({
  value,
  children,
}: Readonly<{
  value: ProjectPageContextValue;
  children: React.ReactNode;
}>) {
  return (
    <ProjectPageContext.Provider value={value}>
      {children}
    </ProjectPageContext.Provider>
  );
}
